import { render, staticRenderFns } from "./UiConfTip.vue?vue&type=template&id=a9f580ac&scoped=true&"
import script from "./UiConfTip.vue?vue&type=script&lang=js&"
export * from "./UiConfTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f580ac",
  null
  
)

export default component.exports